var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_1405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_388_1405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.7217 0.4021H0.72168V76.4021H76.7217V0.4021Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_388_1405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4304 68.3408L29.4302 68.3412L24.6289 63.5399C24.6506 63.8344 24.6617 64.1319 24.6617 64.4321C24.6617 71.043 19.3025 76.4021 12.6917 76.4021C6.08082 76.4021 0.72168 71.043 0.72168 64.4321C0.72168 57.8212 6.08082 52.4621 12.6917 52.4621C12.9918 52.4621 13.2894 52.4731 13.584 52.4948L8.64951 47.5605L8.65053 47.5593C3.74589 42.5559 0.72168 35.7021 0.72168 28.1421C0.72168 12.8217 13.1413 0.4021 28.4617 0.4021C36.0217 0.4021 42.8755 3.42631 47.8789 8.33095L47.8797 8.33004L48.0283 8.47832C48.0606 8.51069 48.0932 8.54318 48.1255 8.57571L52.8144 13.2647C52.7927 12.97 52.7817 12.6723 52.7817 12.3721C52.7817 5.76124 58.1408 0.4021 64.7517 0.4021C71.3625 0.4021 76.7217 5.76124 76.7217 12.3721C76.7217 18.983 71.3625 24.3421 64.7517 24.3421C64.4515 24.3421 64.1539 24.331 63.8591 24.3093L68.5486 28.9989C68.5809 29.0309 68.6129 29.063 68.6448 29.0951L68.6604 29.1108C73.6429 34.1256 76.7217 41.0344 76.7217 48.6621C76.7217 63.9826 64.3021 76.4021 48.9817 76.4021C41.3539 76.4021 34.4452 73.3233 29.4304 68.3408Z",
    fill: "#3040D0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_1405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white",
    transform: "translate(0.72168 0.4021)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHug);
export default __webpack_public_path__ + "static/media/hug.80b1d8a92bc185af76177eca3ed344da.svg";
export { ForwardRef as ReactComponent };